export default __webpack_public_path__ + "static/media/clicou-contratou.7880b506.png";